import { useDispatch, useSelector } from 'react-redux';

import { getIsAvailableOpportunity } from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { haveOddsChanged } from '@swf/sports/utils/updateMarket';

/**
 * Monitors odds changes and allows users to accept them
 */
const useOddsChanges = () => {
  const acceptedOdds = useSelector(select.betSlip.acceptedOdds);
  const opportunities = useSelector(select.betSlip.opportunities);
  const dispatch = useDispatch<Dispatch>();

  return {
    haveOddsChanged: [...opportunities.SINGLE, ...opportunities.MULTIPLE].some((opportunity) => {
      const acceptedOpportunityOdds = acceptedOdds[opportunity.id];
      return (
        getIsAvailableOpportunity(opportunity) &&
        acceptedOpportunityOdds &&
        haveOddsChanged(opportunity.winRunnerOdds, acceptedOpportunityOdds)
      );
    }),
    acceptOddsChanges() {
      dispatch.betSlip.priceChangesAccepted(opportunities);
    }
  };
};

export default useOddsChanges;
